import {createContext} from "react";

export const ShippingMethodFormContext = createContext({
    isApi: false,
    setIsApi: () => {},
    isWaybill: false,
    setIsWaybill: () => {},
    isReturnWaybill: false,
    setIsReturnWaybill: () => {},
})
